export type MonitoringSound = 'som1' | 'som2' | 'som3';

export const DEFAULT_MONITORING_SOUND: MonitoringSound = 'som1';

export const MONITORING_SOUNDS: Array<{ value: MonitoringSound; label: string }> = [
  { value: 'som1', label: 'Som 1' },
  { value: 'som2', label: 'Som 2' },
  { value: 'som3', label: 'Som 3' },
];

interface Note {
  frequency: number;
  start: number;
  decay: number;
}

const PARTIALS = [
  { ratio: 1, gain: 1 },
  { ratio: 2, gain: 0.28 },
  { ratio: 3, gain: 0.08 },
];
const PEAK = 0.2;
const ATTACK = 0.008;

const TONES: Record<string, Note[]> = {
  som2: [
    { frequency: 783.99, start: 0, decay: 0.55 },
    { frequency: 1046.5, start: 0.16, decay: 0.8 },
  ],
  som3: [
    { frequency: 1046.5, start: 0, decay: 0.3 },
    { frequency: 1318.51, start: 0.09, decay: 0.3 },
    { frequency: 1567.98, start: 0.18, decay: 0.5 },
  ],
};

let audioContext: AudioContext | null = null;

const playDefault = (): void => {
  const audio = document.getElementById('aviso_sonoro') as HTMLAudioElement | null;
  if (!audio) return;

  audio.currentTime = 0;
  audio.play().catch(() => {});
};

const playTone = (sound: string): boolean => {
  const Context = window.AudioContext || (window as any).webkitAudioContext;
  if (!Context) return false;

  try {
    audioContext = audioContext || new Context();
    const context = audioContext as AudioContext;
    if (context.state === 'suspended') context.resume().catch(() => {});

    TONES[sound].forEach(({ frequency, start, decay }) => {
      const begin = context.currentTime + start;

      PARTIALS.forEach(({ ratio, gain: level }) => {
        const oscillator = context.createOscillator();
        const gain = context.createGain();

        oscillator.type = 'sine';
        oscillator.frequency.value = frequency * ratio;
        gain.gain.setValueAtTime(0.0001, begin);
        gain.gain.linearRampToValueAtTime(PEAK * level, begin + ATTACK);
        gain.gain.exponentialRampToValueAtTime(0.0001, begin + decay / ratio);
        oscillator.connect(gain);
        gain.connect(context.destination);
        oscillator.start(begin);
        oscillator.stop(begin + decay / ratio + 0.02);
      });
    });

    return true;
  } catch (error) {
    return false;
  }
};

export const playMonitoringSound = (sound?: string | null): void => {
  if (sound && TONES[sound] && playTone(sound)) return;

  playDefault();
};
